import React from 'react';
import { Button, Input, Space } from 'antd';
import { ClearOutlined, PlusOutlined, ReloadOutlined, SearchOutlined } from '@ant-design/icons';

export default function UsersToolbar({ searchText, onSearchChange, onCreate, onRefresh, refreshing }) {
    return (
        <>
            <h2>User Management</h2>
            <Space>
                <Input
                    placeholder="Search users by username or email"
                    value={searchText}
                    onChange={e => onSearchChange(e.target.value)}
                    prefix={<SearchOutlined />}
                    suffix={
                        searchText && (
                            <ClearOutlined
                                onClick={() => onSearchChange('')}
                                style={{ cursor: 'pointer', color: '#999' }}
                            />
                        )
                    }
                    style={{ width: 300 }}
                    allowClear
                />
                <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
                    Add User
                </Button>
                <Button icon={<ReloadOutlined />} onClick={onRefresh} loading={refreshing}>
                    Refresh
                </Button>
            </Space>
        </>
    );
}
